var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('simple-page', {
    scopedSlots: _vm._u([{
      key: "pageItem",
      fn: function fn() {
        return [_c('breadcrumb', {
          attrs: {
            "items": _vm.breadcrumbItems
          }
        }), _c('pending-items-internal', {
          attrs: {
            "title": false
          }
        })];
      },
      proxy: true
    }, {
      key: "pageTitle",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between gap-3 align-items-center flex-grow-1 flex-wrap"
        }, [_c('h1', {
          staticClass: "text-upper-case m-0"
        }, [_vm._v("Plan Change Eligible")]), _c('div', {
          staticClass: "btn-planswitch-btn"
        }, [_c('a', {
          staticClass: "univ-btn m-0 px-3 d-flex align-items-center justify-content-center gap-1",
          attrs: {
            "href": "/plan-switch-history"
          }
        }, [_c('span', {
          staticClass: "icon-wrapper"
        }, [_c('svg', {
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "17",
            "height": "17",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M12 21q-3.45 0-6.012-2.287T3.05 13H5.1q.35 2.6 2.313 4.3T12 19q2.925 0 4.963-2.037T19 12t-2.037-4.962T12 5q-1.725 0-3.225.8T6.25 8H9v2H3V4h2v2.35q1.275-1.6 3.113-2.475T12 3q1.875 0 3.513.713t2.85 1.924t1.925 2.85T21 12t-.712 3.513t-1.925 2.85t-2.85 1.925T12 21m2.8-4.8L11 12.4V7h2v4.6l3.2 3.2z"
          }
        })])]), _vm._v(" View Plan Switch History ")])])])];
      },
      proxy: true
    }, {
      key: "filter",
      fn: function fn() {
        return [_c('pending-renewals-filter', {
          attrs: {
            "filters": _vm.filterQuery
          },
          on: {
            "onSearch": _vm.filterData
          }
        })];
      },
      proxy: true
    }, {
      key: "topPagination",
      fn: function fn() {
        return [_c('div', {
          staticClass: "top-pagination"
        }, [_c('pagination', {
          attrs: {
            "rows": _vm.rows,
            "filters": _vm.filterQuery
          },
          on: {
            "update:rows": function updateRows($event) {
              _vm.rows = $event;
            }
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "table",
      fn: function fn() {
        return [_c('clients-data', {
          attrs: {
            "memberLists": _vm.rows,
            "planSwitch": true
          }
        }), _c('pagination', {
          attrs: {
            "rows": _vm.rows,
            "filters": _vm.filterQuery
          },
          on: {
            "update:rows": function updateRows($event) {
              _vm.rows = $event;
            }
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }